module.exports = __webpack_public_path__ + "img/customer.9954e1b1.svg";